/**
 * THREE.JS ShaderMaterial that removes a specified color (e.g. greens screen)
 * from a texture. Shader code by https://github.com/Mugen87 on THREE.js forum:
 * https://discourse.threejs.org/t/production-ready-green-screen-with-three-js/23113/2
 */
//@ts-ignore
import { ColorRepresentation } from 'three/src/utils';

import * as constants from './constants';

// eslint-disable-next-line new-cap
function getThreeX(THREE: any) {
  class ChromaKeyMaterial extends THREE.ShaderMaterial {
    /**
     *
     * @param {string} video Image or video to load into material's texture
     * @param {ColorRepresentation} keyColor
     * @param {number} width
     * @param {number} height
     * @param {number} similarity
     * @param {number} smoothness
     * @param {number} spill
     */
    constructor(
      video,
      keyColor,
      width,
      height,
      similarity = constants.DEFAULT_VALUES.SIMILARITY,
      smoothness = constants.DEFAULT_VALUES.SMOOTHNESS,
      spill = constants.DEFAULT_VALUES.SPILL,
    ) {
      super();

      this.video = video;
      this.texture = new THREE.VideoTexture(this.video);

      const chromaKeyColor = new THREE.Color(keyColor);

      this.update = function () {
        if (this.texture) {
          this.texture.needsUpdate = true;
        }
      };

      this.setValues({
        uniforms: {
          tex: {
            value: this.texture,
          },
          keyColor: { value: chromaKeyColor },
          texWidth: { value: width },
          texHeight: { value: height },
          similarity: { value: similarity },
          smoothness: { value: smoothness },
          spill: { value: spill },
        },
        vertexShader: constants.VERTEX_SHADER,
        fragmentShader: constants.FRAGMENT_SHADER,
        transparent: true,
      });
    }

    startVideo() {
      this.video?.play();
    }

    stopVideo() {
      this.video?.pause();
    }
  }

  return {
    ChromaKeyMaterial: ChromaKeyMaterial as any,
  };
}

export default getThreeX;
